import { useCallback, useContext, useRef } from 'react';
import { Paragraph } from 'elements/Text';
import { TextArea, Button } from 'elements/Input';
import { UserContext } from 'contexts/UserContext';
import Box from 'elements/Box';

const DirectoryInput = ({ onCancel, onConfirm }) => {
  const directoryRef = useRef()
  const { saveDirectory, directory } = useContext(UserContext);
  const handleSave = useCallback(event => {
    saveDirectory(directoryRef.current.value);
    onConfirm();
  }, [onConfirm, saveDirectory, directoryRef]);

  return (
    <>
      <Paragraph>
        The Directory lets you earmark puzzle URLs for later. Input one URL per line:
      </Paragraph>
      <TextArea
        ref={directoryRef}
        defaultValue={directory}
        fluid
      />
      <Box
        display="flex"
        justifyContent="flex-end"
        alignItems="center"
        gridGap="1rem"
        fluid
      >
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={handleSave}>Save</Button>
      </Box>
    </>
  )
};

export default DirectoryInput;
